let _fontCanvas = null;

const fontStyles = {};

const textExceedsThreshold = (el, text, thres) => {
  if (!text) return false;

  // huge titles wrap at ~8 letter M's
  if (text.length < 8) return false;

  // summaries wrap at ~80 letter i's
  const lines = text.split('\n');
  if (lines.filter(l => l.length > 80).length) return true;

  // read from the h1/h2 if we made the field larger using rich-text
  let headingTagName;
  if (el.children.length && (headingTagName = el.children[0].tagName.match(/(h1|h2)/i))) {
    el = el.children[0];
  }

  // cache our font value
  const className = el.className;
  const key = `${headingTagName};${className}`;

  let fontStyle = fontStyles[key];

  if (!fontStyle) {
    fontStyle = getComputedStyle(el).font;
    fontStyles[key] = fontStyle;
  }

  text = text.trimRight();

  const fontCanvas = _fontCanvas || (_fontCanvas = document.createElement("canvas"));
  const context = fontCanvas.getContext("2d");

  context.font = fontStyle;
  // also consider shorting lines longest to shortest
  for (const l of lines) {
    const w = context.measureText(l).width;
    if (w > thres) return true;
  }
  return false;

};

export { textExceedsThreshold };



// WEBPACK FOOTER //
// ./starling/src/lib/text.js